import { Trans } from '@pulsex/localization'

export default Trans
